import { render } from "./AdminPorfolio.vue?vue&type=template&id=47b07eda"
import script from "./AdminPorfolio.vue?vue&type=script&lang=js"
export * from "./AdminPorfolio.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Gelo\\Desktop\\Firebase Project\\eporrtfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__